export const SET_USER = 'SET_USER';
export const SET_LOADING = 'SET_LOADING';
export const RESET = 'RESET';
export const SET_USER_ROLES = 'SET_USER_ROLES';
export const NEW_USER = 'NEW_USER';
